
// Usage: {{$appConfig['key']}} or this.$appConfig['key']

const appConfig = {

    // Header
    'link_logo_en':     'https://www.onlinetherapyuser.ca/',
    'link_urgent_en':   'https://www.onlinetherapyuser.ca/urgent-care',
    'unit_email':       'Online.Therapy.User@uregina.ca',

    // Self Enrollment
    'allow_self_enrolment': false,
    'allow_videos': true,


    // Footer
    'link_contact_us_en':      'https://www.onlinetherapyuser.ca/contact-us',
    'link_privacy_policy_en':  'https://www.onlinetherapyuser.ca/privacy-policy',
    'link_terms_use_en':       'https://www.onlinetherapyuser.ca/terms-use',
    'link_faq_en':             'https://www.onlinetherapyuser.ca/frequently-asked-questions',
    'link_forum_terms_use_en': ' ',

}
  
export { appConfig }
